import { render, staticRenderFns } from "./Sesi.vue?vue&type=template&id=40c005f6&scoped=true"
import script from "./Sesi.vue?vue&type=script&lang=js"
export * from "./Sesi.vue?vue&type=script&lang=js"
import style0 from "./Sesi.vue?vue&type=style&index=0&id=40c005f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c005f6",
  null
  
)

export default component.exports